<template>
  <button @click="$emit('click')" type="button" class="btn mr-2 mt-2 mb-4 btn-primary">
    <slot></slot>
  </button>
</template>
<script>
export default {
  name: "Button"
};
</script>